import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "provision_contents_wrapper" }

import Provision from '@/components/Provision.vue';
import { computed } from '@vue/reactivity';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProvisionView',
  setup(__props) {

const router = useRouter();
const store = useStore();

const provision = computed(() => {
  return store.getters['provision/provision'];
});

const submit = (value: object) => {
  store.commit('provision/set', value);
  router.push({ name: 'e11' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Provision, {
      provision: _unref(provision),
      onSubmit: submit
    }, null, 8, ["provision"])
  ]))
}
}

})